import { formatDateTime } from '../../../common/utils';

export const ACCENT = '#137274';
export const ACCENT_HOVER = '#0f5c5e';

export const DISCUSSION_TAGS = [
  'Question',
  'Solution',
  'General',
  'Interview',
  'Feedback',
  'Bug',
];

export const TAG_COLORS = {
  Question: '#2563eb',
  Solution: '#1a7f37',
  General: '#137274',
  Interview: '#7c3aed',
  Feedback: '#d97706',
  Bug: '#cf222e',
};

export const timeAgo = (date) => {
  const d = new Date(date);
  const diff = Date.now() - d.getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 30) return `${days}d ago`;
  return formatDateTime(date).date;
};

export const insertCommentInTree = (comments, newComment, parentId = null) => {
  if (!parentId) return [...comments, { ...newComment, replies: [] }];
  const walk = (nodes) =>
    nodes.map((node) => {
      if (node.id === parentId) {
        return {
          ...node,
          replyCount: (node.replyCount || 0) + 1,
          replies: [...(node.replies || []), { ...newComment, replies: [] }],
        };
      }
      if (node.replies?.length) {
        return { ...node, replies: walk(node.replies) };
      }
      return node;
    });
  return walk(comments);
};

export const removeCommentFromTree = (comments, commentId) => {
  const walk = (nodes) =>
    nodes
      .filter((n) => n.id !== commentId)
      .map((n) => ({
        ...n,
        replies: n.replies?.length ? walk(n.replies) : [],
      }));
  return walk(comments);
};

export const updateCommentInTree = (comments, commentId, patch) => {
  const walk = (nodes) =>
    nodes.map((n) => {
      if (n.id === commentId) return { ...n, ...patch };
      if (n.replies?.length) return { ...n, replies: walk(n.replies) };
      return n;
    });
  return walk(comments);
};

export const countComments = (comments) =>
  comments.reduce(
    (sum, c) => sum + 1 + (c.replies?.length ? countComments(c.replies) : 0),
    0,
  );
